import { forwardRef } from "react";
const SvgUser = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M12.5839 14C11.8124 12.2341 10.0503 11 7.99997 11C5.94965 11 4.18757 12.2341 3.41602 14M11 5C11 6.65685 9.65683 8 7.99997 8C6.34312 8 4.99997 6.65685 4.99997 5C4.99997 3.34315 6.34312 2 7.99997 2C9.65683 2 11 3.34315 11 5Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;